import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getDecisionList = (state: IRootState) => state.decisionList;
export const getDecisionListData = (state: IRootState) => getDecisionList(state).data;
export const getDecisionListPage = (state: IRootState) => getDecisionList(state).page;
export const getDecisionListPageCount = (state: IRootState) => getDecisionList(state).pageCount;
export const getDecisionListTotalCount = (state: IRootState) => getDecisionList(state).totalCount;
export const getDecisionListSearchValue = (state: IRootState) => getDecisionList(state).searchValue;
export const getDecisionListFilterParam = (state: IRootState) => getDecisionList(state).filterParam;
export const getDecisionListOrder = (state: IRootState) => getDecisionList(state).order;
export const getDecisionListFindData = (state: IRootState) => getDecisionList(state).findData;
